<template>
  <address :class="$style.container">
    <img :src="photoUrl" :alt="name" />
    <div>
      <p>{{name}}</p>
      <p>{{phoneNumber.nationalNumber}}</p>
    </div>

    <ContactButtons
        :class="$style.actions"
        :contact="contact"
        :phone="phoneNumber"
        :hasSmsButton="false" />
  </address>
</template>

<script>
  import ContactButtons from '@/components/shared/ContactButtons'
  
  export default {
    components: {
      ContactButtons
    },
    props: {
      name: String,
      photoUrl: String,
      phoneNumber: Object,
      contact: Object
    }
  }
</script>

<style module lang="less" src="./contact.less"></style>



// WEBPACK FOOTER //
// contact.vue?4ac1bd74